interface IAppConfig {
  baseUrl?: string;
  authUrl?: string;
}

export const appConfig: IAppConfig = {
  baseUrl: process.env.REACT_APP_URL,
  authUrl: process.env.REACT_APP_AUTH_URL,
};
